import React from "react";
import data from "./../Data/ServicesData.js";

function Services() {
  return (
    <section id="service-section" className="section-2">
      <div className="row">
        <div className="section-2-content">
          <div className="services" data-aos="fade-right" data-aos-delay="200">
            <h2>My awesome services</h2>
            <p>
              Experience handling of complex design and extensions to meet
              organization’s and client's needs
            </p>
            <div className="button">
              <a href="/doc/daniel_cv.pdf" target="_blank" className="btn-full">
                Download cv
              </a>
            </div>
          </div>
          <>
            {data.map((card, i) => {
              return (
                <div key={card.id} className="card-card">
                  <div className="card" data-aos={card.fadeBehaviour}>
                    <img src={card.img} alt="" />
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                    <div className="button">
                      <a href="#languages_library" className="btn-ghost">
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        </div>
      </div>
    </section>
  );
}

export default Services;
